<template>
    <div>
        <a-drawer
                :title='title'
                :visible="visibleJurisdiction"
                v-bind="drawerConfig"
                :body-style="{ paddingBottom: '80px' }"
                @close="onClose"
        >
            <a-checkbox disabled v-model="checkAll" @change="handleCheckAllChange">
                全选
            </a-checkbox>
            <a-tree
                    v-model="checkedKeys"
                    checkable
                    :defaultExpandedKeys="defaultExpandedKeys"
                    :expanded-keys="expandedKeys"
                    :auto-expand-parent="autoExpandParent"
                    :selected-keys="selectedKeys"
                    :replaceFields="replaceFields"
                    :tree-data="treeData"
                    @expand="onExpand"
                    @check="onCheck"
                    disabled
            />
            <div class="drawer-btn">
<!--                <a-button :style="{ marginRight: '8px' }" @click="onClose">-->
<!--                    取消-->
<!--                </a-button>-->
<!--                <a-button type="primary" @click="onSubmit">-->
<!--                    确定-->
<!--                </a-button>-->
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import API from "../api";
    import {submitForm, drawerConfig} from "../../../utils/utils"

    export default {
        name: "jurisdictionForm",
        props: ["visibleJurisdiction", "title", "jurisdictionId"],
        data() {
            return {
                checkAll: false,
                replaceFields: {children: 'children', title: 'name', key: 'id'},
                defaultExpandedKeys:[],
                expandedKeys: [],
                autoExpandParent: true,
                checkedKeys: [],
                selectedKeys: [],
                treeData: [],
                num: 0,
                fnum: 0,
                drawerConfig: drawerConfig,
                ids: [],
                idsArr:[],
                form: {
                    ids: "",
                },
                checkedKeysAll:[]
            }
        },
        watch: {
            checkedKeys(val) {
                this.form.ids = val
            },
            jurisdictionId: function (a, b) {
                if (a != "") {
                    API.customer.GET_JURISDICTION(a).then(res => {
                        this.treeData = res.data.data
                        Promise.resolve(
                            this.disabledList(this.treeData)
                        ).then((res) => {
                            this.getfouc(this.treeData )
                            this.form.a_customer_id = a
                            if (this.checkedKeys.length + this.fnum == this.ids.length) {
                                this.checkAll = true
                            }
                        })

                    })
                } else {
                    this.form.a_role_id = ''
                }
            }
        },
        methods: {
            disabledList(data){
                data.map((item,index)=>{
                    // item.disabled=true
                    if(item.children&&item.children.length>0){
                        this.disabledList (item.children)
                    }
                })
                return data
            },
            handleCheckAllChange(val) {
                if (this.checkAll) {
                    this.checkedKeys = this.ids
                } else {
                    this.checkedKeys = []
                }
            },
            getfouc(list) {
                list.map((value, key, arr) => {
                    if (value.children) {
                        this.fnum++
                        this.ids.push(value.id)
                        this.getfouc(value.children)
                    } else {
                        this.num++
                        this.ids.push(value.id)
                        if (value.is_check == 1) {
                            this.checkedKeys.push(value.id)
                            this.idsArr.push(value.id)
                        }
                    }

                })
            },
            onExpand(expandedKeys) {
                this.expandedKeys = expandedKeys;
                this.autoExpandParent = false;

            },
            onCheck(checkedKeys,e) {
                this.idsArr=[...checkedKeys , ...e.halfCheckedKeys]
                this.checkedKeys = checkedKeys;
                if (this.checkedKeys.length == this.ids.length) {
                    this.checkAll = true
                } else {
                    this.checkAll = false
                }
            },
            onSelect(selectedKeys, info) {
                this.selectedKeys = selectedKeys;
            },
            onClose() {
                this.checkAll = false
                this.selectedKeys = []
                this.checkedKeys = []
                this.defaultExpandedKeys=[]
                this.num = 0
                this.fnum = 0
                this.ids = []
                this.$emit("changVisible", false);
            },
            onSubmit() {
                let _this = this;
                // this.checkAll== true ? this.form.ids=this.checkedKeys:this.form.ids=this.checkedKeysAll

              if(this.checkAll==true) { this.form.ids=this.ids } else{
                   this.checkedKeys.length<1? this.form.ids=[]:this.form.ids=this.idsArr  }
                // console.log(this.form.ids)
                // return
                submitForm(API.customer.SUBMIT_JURISDICTION, this.form).then(res => {
                    if (res == true) {
                        this.onClose()

                    } else {
                    }
                })
            },
        },

    }
</script>

<style scoped>

</style>
